
import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from "@/components/ui/card";

interface AuthCardProps {
  activeView: "signIn" | "signUp" | "smsSignUp" | "phoneSignUp" | "forgotPassword" | "resetPassword";
  setActiveView: (view: "signIn" | "signUp" | "smsSignUp" | "phoneSignUp" | "forgotPassword" | "resetPassword") => void;
  title: string;
  description: string;
  children: ReactNode;
}

const AuthCard = ({
  activeView,
  setActiveView,
  title,
  description,
  children
}: AuthCardProps) => {
  return (
    <Card className="max-w-md w-full">
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-center">
          {title}
        </CardTitle>
        <CardDescription className="text-center">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
      <CardFooter className="flex flex-col space-y-4">
        {activeView === 'signIn' && (
          <>
            <Button
              variant="link"
              className="w-full"
              onClick={() => setActiveView('forgotPassword')}
              type="button"
            >
              Forgot your password?
            </Button>
            <div className="text-sm text-center">
              Don't have an account?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => setActiveView('signUp')}
                type="button"
              >
                Create one
              </Button>
            </div>
          </>
        )}
        
        {activeView === 'signUp' && (
          <div className="text-sm text-center">
            <div className="mb-2">
              Already have an account?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => setActiveView('signIn')}
                type="button"
              >
                Sign in
              </Button>
            </div>
            <div>
              Prefer phone signup?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => setActiveView('phoneSignUp')}
                type="button"
              >
                Use phone number
              </Button>
            </div>
          </div>
        )}
        
        {activeView === 'phoneSignUp' && (
          <div className="text-sm text-center">
            <div className="mb-2">
              Already have an account?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => setActiveView('signIn')}
                type="button"
              >
                Sign in
              </Button>
            </div>
            <div>
              Prefer email signup?{" "}
              <Button
                variant="link"
                className="p-0"
                onClick={() => setActiveView('signUp')}
                type="button"
              >
                Use email instead
              </Button>
            </div>
          </div>
        )}
        
        {activeView === 'smsSignUp' && (
          <div className="text-sm text-center text-muted-foreground">
            Already have an account?{" "}
            <Button
              variant="link"
              className="p-0"
              onClick={() => setActiveView('signIn')}
              type="button"
            >
              Sign in instead
            </Button>
          </div>
        )}
        
        {(activeView === 'forgotPassword' || activeView === 'resetPassword') && (
          <Button
            variant="link"
            className="w-full"
            onClick={() => setActiveView('signIn')}
            type="button"
          >
            Back to sign in
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default AuthCard;
